import { Subject } from 'rxjs';
import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
class WebSocketMessage {}
class WebSocketService {
  constructor(webSocketConfig) {
    this.webSocketConfig = webSocketConfig;
    this.types = new Map();
    this.closedAt = [];
    this.openStateChanged = new Subject();
    this.initializeWebSocket();
    if (webSocketConfig.tokenProvider && !webSocketConfig.resetToken) {
      throw Error('WebSocketConfig contains a token provider but no reset token method.');
    }
  }
  isOpen() {
    return this.ws?.readyState === WebSocket.OPEN;
  }
  // noinspection JSUnusedGlobalSymbols
  getOpenStateChanged() {
    return this.openStateChanged.asObservable();
  }
  initializeWebSocket() {
    if (!this.webSocketPossible()) {
      setTimeout(() => {
        if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
          this.initializeWebSocket();
        }
      }, 60000);
      return;
    }
    if (this.ws && this.ws.readyState !== WebSocket.CLOSED) {
      this.ws.close();
      this.openStateChanged.next(this.isOpen());
    }
    const url = this.webSocketConfig.tokenProvider ? this.webSocketConfig.url + '?accessToken=' + this.webSocketConfig.tokenProvider() : this.webSocketConfig.url;
    if (!url) {
      return;
    }
    this.ws = new WebSocket(url);
    this.ws.onopen = () => {
      this.syncTypeSubscription();
      this.openStateChanged.next(this.isOpen());
    };
    this.ws.onmessage = event => {
      const message = JSON.parse(event.data);
      if (message.type !== 'WS_HB' && message.type && this.types.get(message.type)) {
        setTimeout(() => this.types.get(message.type)?.next(message.content), 0);
      }
    };
    this.ws.onerror = event => {
      console.log(event);
      this.ws?.close();
      this.openStateChanged.next(this.isOpen());
    };
    this.ws.onclose = event => {
      console.log(event);
      if (event.code === 1003) {
        this.webSocketConfig.resetToken?.();
      }
      this.closedAt.push(Date.now());
      this.openStateChanged.next(this.isOpen());
      this.initializeWebSocket();
    };
  }
  // noinspection JSUnusedGlobalSymbols
  subscribeType(type) {
    if (!this.types.get(type)) {
      this.types.set(type, new Subject());
      this.syncTypeSubscription();
    }
    return this.types.get(type).asObservable();
  }
  // noinspection JSUnusedGlobalSymbols
  unsubscribeType(type) {
    this.types.get(type)?.complete();
    this.types.delete(type);
    this.syncTypeSubscription();
  }
  webSocketPossible() {
    if (this.webSocketConfig.tokenProvider && !this.webSocketConfig.tokenProvider()) {
      return false;
    }
    this.closedAt = this.closedAt.filter(value => Date.now() - value < 30000);
    return this.closedAt.length < 5;
  }
  syncTypeSubscription() {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      const message = new WebSocketMessage();
      message.type = 'WS_SR';
      message.content = Array.from(this.types.keys());
      this.ws.send(JSON.stringify(message));
    } else {
      this.initializeWebSocket();
    }
  }
}
let WebSocketModule = /*#__PURE__*/(() => {
  class WebSocketModule {
    static forRoot(...configs) {
      if (configs.length === 1) {
        return {
          ngModule: WebSocketModule,
          providers: [{
            provide: WebSocketService,
            useValue: new WebSocketService(configs[0])
          }]
        };
      }
      configs.forEach(config => {
        if (!config.injectName) {
          throw new Error('web socket configs need injectName');
        }
      });
      return {
        ngModule: WebSocketModule,
        providers: configs.map(config => ({
          provide: config.injectName,
          useValue: new WebSocketService(config)
        }))
      };
    }
    static {
      this.ɵfac = function WebSocketModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WebSocketModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: WebSocketModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return WebSocketModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class WebSocketConfig {}

/*
 * Public API Surface of web-socket
 */

/**
 * Generated bundle index. Do not edit.
 */

export { WebSocketConfig, WebSocketMessage, WebSocketModule, WebSocketService };
